import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';
import { toast } from 'react-toastify';

/**
 * Descarga el Excel de matriz de extras (plantilla con pestaña BBDD alimentada)
 * conectando con la fuente de datos histórica y actual.
 *
 * @param {Object} params - { year, month, dateFrom, dateTo }
 * @returns {Promise<boolean>}
 */
export async function exportExtrasMatrix(params = {}) {
  try {
    const response = await getAPIResponse(
      '/v1/after-sales-extras/export-matrix',
      params,
      'GET',
      true,
      'blob'
    );

    if (!response || !response.data) {
      toast.error('No se pudo generar el informe matriz de extras.');
      return false;
    }

    // Determine filename from content-disposition or default
    let filename = `extras_matriz_a3_${new Date().toISOString().split('T')[0]}.xlsx`;
    const disposition = response.headers?.['content-disposition'];
    if (disposition && disposition.indexOf('filename=') !== -1) {
      const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (match && match[1]) {
        filename = match[1].replace(/['"]/g, '');
      }
    }

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    toast.success(`Matriz de extras generada y descargada: ${filename}`);
    return true;
  } catch (error) {
    console.error('Error al exportar matriz de extras:', error);
    toast.error('Error al procesar la descarga de la matriz de extras.');
    return false;
  }
}
